// import { useTranslation } from '@/app/'

export const rentLangName = (rentLang: number): string => {
  //   const { i18n } = useTranslation(lng, 'footer')
  //   const t = i18n.getFixedT(lng, 'footer')
  switch (rentLang) {
    case 1:
      return 'langCN'
    case 2:
      return 'langHK'
    default:
      return 'Unknown Language'
  }
}

export const formatDateTime = (date: string, type: boolean = false): string => {
  const year = date.slice(0, 4)
  const month = date.slice(4, 6)
  const day = date.slice(6, 8)
  const hour = date.slice(8, 10)
  const minute = date.slice(10, 12)
  const second = date.slice(12, 14)

  return type ? `${year}-${month}-${day} ${hour}:${minute}:${second}` : `${year}-${month}-${day}`
}

export const objectToFormData = (obj: any) => {
  const temp_formData = new FormData()
  for (const key in obj) {
    if (obj.hasOwnProperty(key)) {
      temp_formData.append(key, obj[key])
    }
  }
  return temp_formData
}

export const loginToRedirectUrl = (router: any, curPath: string) => {
  router.push(`/login?redirect=${curPath}`)
}
export const twoDecimal = (num: number) => {
  return Math.round(num * 100) / 100
}

export const insertImagesInList = (list: any[], images: any[]) => {
  if (!list.length) return []
  if (!images.length) return [...list]

  const result = []
  let imageIndex = 0

  // 首先在数组最前面插入第一张图片
  result.push(images[imageIndex++])

  for (let i = 0; i < list.length; i++) {
    result.push(list[i])

    // 每3个数字处理一次
    if ((i + 1) % 3 === 0) {
      // 判断这次应该插入1张还是2张图片
      const group = Math.floor((i + 1) / 3)
      const insertAmount = group % 2 === 1 ? 2 : 1

      // 插入相应数量的图片
      for (let j = 0; j < insertAmount && imageIndex < images.length; j++) {
        result.push(images[imageIndex++])
      }
    }
  }

  return result
}

export const formatDiscountNum = (discount: number) => {
  return `${discount}`.endsWith('0') ? discount / 10 : discount
}

// 将查询参数转换为动态路由路径
export function buildSearchParamsToRoutePath(lng: string, mainPath: string, params: Record<string, any> = {}) {
  const pathSegments: string[] = []

  // 参数顺序：category > publisher > set > order > page > 其他
  if (params.category) {
    pathSegments.push('category', params.category.toString())
  }

  if (params.publisher) {
    pathSegments.push('publisher', params.publisher.toString())
  }

  if (params.set) {
    pathSegments.push('set', params.set.toString())
  }

  if (params.searchText) {
    pathSegments.push('searchText', encodeURIComponent(params.searchText))
  }

  if (params.bookLanguage) {
    pathSegments.push('bookLanguage', params.bookLanguage)
  }

  if (params.order && params.order !== '0') {
    pathSegments.push('order', params.order.toString())
  }

  if (params.page && params.page !== 1) {
    pathSegments.push('page', params.page.toString())
  }

  if (params.discountType && params.discountType !== 0) {
    pathSegments.push('discountType', params.discountType.toString())
  }

  const pathString = pathSegments.length > 0 ? `/${pathSegments.join('/')}` : ''
  return `/${lng}/${mainPath}${pathString}`
}

// 将动态路由参数转换回查询参数格式
export function parseRouteParamsToSearchParams(params: string[] = []) {
  const searchParams: Record<string, any> = {}

  for (let i = 0; i < params.length; i += 2) {
    const key = params[i]
    const value = params[i + 1]

    if (key && value !== undefined) {
      switch (key) {
        case 'page':
          searchParams.page = value
          break
        case 'order':
          searchParams.order = value
          break
        case 'category':
          searchParams.category = value
          break
        case 'publisher':
          searchParams.publisher = value
          break
        case 'set':
          searchParams.set = value
          break
        case 'searchText':
          searchParams.searchText = decodeURIComponent(value)
          break
        case 'bookLanguage':
          searchParams.bookLanguage = value
          break
        case 'discountType':
          searchParams.discountType = value
          break
      }
    }
  }

  return searchParams
}
